import { captureLinkingPhonePrefillFromCurrentUrl } from "./linking-phone.js";
import { funnelVisitorId } from "./share-link-funnel.js";

export const ATTRIBUTION_KEY = "mincool.attributionCode";

export async function claimFunnelVisit(accountId, { request, capturePostHogException, code }) {
  const visitorId = funnelVisitorId();
  if (!accountId || !code || !visitorId) return;
  try {
    await request("/api/share-links/claim-visit", {
      method: "POST", body: JSON.stringify({ accountId, code, visitorId }),
    });
  } catch (error) {
    capturePostHogException(error, { error_context: "funnel_visit_claim_failed" });
  }
}


export async function captureShareLinkEntry(code, options, { request, emitAnalyticsEvent, capturePostHogException, store }) {
  const { track = true, entrySurface = "share_link_redirect" } = options;
  if (store && code) {
    store.setItem(ATTRIBUTION_KEY, code);
  }
  captureLinkingPhonePrefillFromCurrentUrl();
  if (code) {
    try {
      const payload = await request("/api/share-links/capture", {
        method: "POST",
        body: JSON.stringify({ code, entrySurface, visitorId: funnelVisitorId({ create: true }) }),
        requireAuth: false,
      });
      if (track && payload?.visitCreated !== false) {
        emitAnalyticsEvent("share_link_clicked", {
          code,
          entry_surface: entrySurface,
          exposure_id: payload?.shareLink?.funnel?.exposureId,
          variant_id: payload?.shareLink?.funnel?.variantId,
          family: payload?.shareLink?.funnel?.family,
          cohort: payload?.shareLink?.funnel?.cohort,
        });
      }
      return payload;
    } catch (error) {
      capturePostHogException(error, {
        error_context: "share_link_capture_failed",
        code,
        entry_surface: entrySurface,
      });
    }
  }
  if (track) {
    emitAnalyticsEvent("share_link_clicked", {
      code,
      entry_surface: entrySurface,
    });
  }
  return { code, captured: true, shareLink: null };
}
